// import { COMMA, ENTER } from '@angular/cdk/keycodes';
// import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
// import { ActivatedRoute, Router } from '@angular/router';
// import { Subscription } from 'rxjs';
// import { TranslateService } from '../../../app/translate';
// import { CurrentSelection, Customer, Equipment, JobSite, Make, SelectionLists } from '../../../app/entities';
// import { AppService } from '../../app.service';
// import { System } from '../wsre-search-on-equipment/wsre-search-on-equipment.component';
// import { LoadingService } from '../../../app/shared/services/loading.service';
// import { InventoryService } from '../inventory/inventory-service.service';
// import { SetupEquipmentService } from '../setup-equipment/setup-equipment.service';
// import { FrameVM, InventorySearchItems, ModelCreateInspection, SystemComponentViewModel, SystemsInInventoryViewModel, WSRECreateIdlerVM } from '../inventory/inventory-models';
// import { FormControl } from '@angular/forms';
// import { JobsiteSelectItem } from '../setup-equipment/setup-equipment.model';
// import { NotificationsService } from 'angular2-notifications';
// import { OrdinalDateAdapter, ORD_DATE_FORMATS } from '../GET_NEW_UI/adapters/ordinal-date-adapter';
// import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
// import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// import { MatSnackBar } from '@angular/material/snack-bar';

import { ENTER, COMMA } from "@angular/cdk/keycodes";
import { Component, OnInit, ChangeDetectorRef, Inject } from "@angular/core";
import { FormControl } from "@angular/forms";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationsService } from "angular2-notifications";
import { Subscription } from "rxjs";
import { AppService } from "../../../app/app.service";
import { SelectionLists, CurrentSelection, Equipment, Customer, JobSite, Make } from "../../../app/entities";
import { TranslateService } from "../../../app/translate";
import { OrdinalDateAdapter, ORD_DATE_FORMATS } from "../GET_NEW_UI/adapters/ordinal-date-adapter";
//import { LoadingService } from "../GET_NEW_UI/shared/loading.service";
import { SystemsInInventoryViewModel, InventorySearchItems, SystemComponentViewModel, WSRECreateIdlerVM, FrameVM, ModelCreateInspection } from "../inventory/inventory-models";
import { InventoryService } from "../inventory/inventory-service.service";
import { JobsiteSelectItem } from "../setup-equipment/setup-equipment.model";
import { SetupEquipmentService } from "../setup-equipment/setup-equipment.service";
import { System } from "../wsre-search-on-equipment/wsre-search-on-equipment.component";
import { DatePipe } from '@angular/common';

@Component({
  selector: 'wsre-quick-chain',
  templateUrl: './wsre-quick-chain.component.html',
  styleUrls: ['./wsre-quick-chain.component.scss'],
  providers: [
    {
      provide: DateAdapter, useClass: OrdinalDateAdapter
    },
    {
      provide: MAT_DATE_FORMATS, useValue: ORD_DATE_FORMATS
    }
  ]
})
export class WsreQuickChainComponent implements OnInit {
  translateSubscription: Subscription;
  userLanguage = "english";
  _loading = 0;
  _dropDownLists: SelectionLists = new SelectionLists();
  _dropDownListsFiltered: SelectionLists = new SelectionLists();
  _currentSelection: CurrentSelection = new CurrentSelection();
  _returnRoute = "";
  _selectedEquipment: Equipment = new Equipment();
  separatorKeysCodes = [ENTER, COMMA];

  items: SystemsInInventoryViewModel[] = [];
  inventorySearchFilter: InventorySearchItems = new InventorySearchItems(2000); // todo : should implement paged table

  equipmentCtrl: FormControl;

  filteredSystems: SystemsInInventoryViewModel[] = [];

  selectedCustomer: Customer;
  isLoading = false;
  selectedJobsite: JobSite;
  selectedMake: Make;
  selectedModel: number;
  private _listFilter: string;

  totalcount = 0;
  avaragecmu = 0;
  chainId: number;
  jobSiteID: number;
  componenetsdetails: SystemComponentViewModel[];

  SystemId: number;
  selected_customerRef: string;
  selected_jobNumber: string;
  selected_oldJobNo: string;
  selected_date: Date = new Date();
  stringDate: string;
  componentList: SystemComponentViewModel[]
  componentList_: SystemComponentViewModel[]
  modelList: JobsiteSelectItem[];
  CopymodelList: JobsiteSelectItem[];

  selectedChainLSide: number;
  selectedChainRSide: number;
  selected_ChainNoLeft: string = ""
  selected_ChainNoRight: string = ""
  selected_customerChainLeft: string
  selected_customerChainRight: string


  leftSideChaininfo: WSRECreateIdlerVM[]
  rightSideChaininfo: WSRECreateIdlerVM[]

  isInventory: boolean = false;



  selected_Chain_L: string;
  selected_Chain_R: string;
  selected_Chain_L_Id: number;
  selected_Chain_R_Id: number;
  jobsites: number;

  isCreateNew: boolean = false;

  selectedChainSide: number = 1;
  noofLinks: number = 0;
  public get listFilter(): string {
    return this._listFilter;
  }
  public set listFilter(v: string) {
    this._listFilter = v;
    this.filteredSystems = this.listFilter
      ? this.performFilter(this.listFilter)
      : this.items;
  }

  performFilter(filter: string): SystemsInInventoryViewModel[] {
    filter = filter.toLowerCase();
    return this.items.filter(s => {
      // tslint:disable-next-line:no-unused-expression
      return s.SerialNumber.toLowerCase().indexOf(filter) !== -1;
    });
  }
  constructor(public dialogRef: MatDialogRef<WsreQuickChainComponent>,
    private _appService: AppService,
    private _translate: TranslateService,
    public snackBar: MatSnackBar,
    private _notify: NotificationsService,
    //private _loadingService: LoadingService,
    private inventoryService: InventoryService,
    private _equipmentService: SetupEquipmentService,
    private ref: ChangeDetectorRef,
    private _router: ActivatedRoute, private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.SystemId = this._router.snapshot.params.id;

    this._appService.setPageTitle("Chain Setup");

    this.isInventory = this.data.isInventory;
    this.inventorySearchFilter.SerialNo = "";
    this.inventorySearchFilter.ModelId = 0;
    this.inventorySearchFilter.CustomerId = 0;
    this.inventorySearchFilter.JobsiteId = 0;
    this.inventorySearchFilter.MakeId = 0;

    //this.selectedChainSide =this.data.selectedChainSide;
    this.selected_Chain_L = this.data.selected_Chain_L;
    this.selected_Chain_R = this.data.selected_Chain_R;
    this.selected_Chain_L_Id = this.data.selected_Chain_L_Id;
    this.selected_Chain_R_Id = this.data.selected_Chain_R_Id;
    this.jobsites = this.data.jobsites;
    this.isCreateNew = this.data.isCreateNew;
    this.selectedChainLSide = this.data.selected_Chain_L_Id;
    this.selectedChainRSide = this.data.selected_Chain_R_Id;
    this.selectedChainSide = this.data.selectedChainSide;

    //if(this.isCreateNew==true){
    //  this.selectedChainSide =this.data.selectedChainSide;
    //}

    console.log("data", this.data, this.isInventory)
    this._loading++;
    this._appService.getCustomerListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.customerList = result;
        this._dropDownListsFiltered.customerList = result;
      },
      error => {
        console.error(error);
      },
      () => {
        this._loading--;
      }
    );
    this._loading++;
    this._appService.getJobSiteListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.jobSiteList = result;
      },
      error => {
        console.error(error);
      },
      () => {
        this._loading--;
      }
    );
    this._loading++;
    this._appService.getMakeListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.makeList = result;
      },
      error => {
        console.error(error);
      },
      () => {
        this._loading--;
      }
    );
    this._loading++;
    this._appService.getModelListForSelection(1, 10000).subscribe(
      result => {
        this._dropDownLists.modelList = result;
      },
      error => {
        console.error(error);
      },
      () => {
        this._loading--;
      }
    );

    this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));
  }
  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }
  updateUserLang(lang: string) {
    this.userLanguage = lang;
    this.ref.detectChanges();
  }


  isWSREEnable: boolean = false;
  arrSystems: System[];

  chainSystemsL: SystemsInInventoryViewModel[];
  chainSystemsR: SystemsInInventoryViewModel[];
  LoadingSpinner: boolean = false;
  LoadChains() {
    this.LoadingSpinner = true;
    this.inventorySearchFilter.IncludeWSRE = true;
    this.inventorySearchFilter.PageNumber = 1;
    //this._loadingService.startLoading();
    this.isLoading = true;
    this.inventoryService
      .searchSystemInInventory(this.inventorySearchFilter)
      .subscribe(
        r => {
          if (r != null) {
            this.items = r.ListSystemInventory;
            if (r.ListSystemInventory != null) {
              let _filteredSystems = r.ListSystemInventory.filter(f => f.SystemTypeName == "Chain");
              this.filteredSystems = _filteredSystems;
              this.chainSystemsL = _filteredSystems;
              //this.chainSystemsR = _filteredSystems.filter(f=>f.Side=="Right");
            }

            //console.log("filteredSystemsL", this.chainSystemsL)
            //console.log("filteredSystemsR", this.chainSystemsR)

            this.LoadingSpinner = false;
            this.isLoading = false;
            //this.finishedLoading();

          } else {
            this.LoadingSpinner = false;
          }
        },
        error => {
          //this.finishedLoading();
          this.isLoading = false;
        }


      );
  }
  ChangeSystemL() {
    console.log("Chnage Left", this.filteredSystems, this.chainSystemsR)
    this.chainSystemsR = this.filteredSystems;

    this.chainSystemsR = this.chainSystemsR.filter(x => x.SystemId != this.selectedChainLSide)
  }
  ChangeSystemR() {
    console.log("Chnage Right", this.filteredSystems, this.chainSystemsL)
    this.chainSystemsL = this.filteredSystems;
    this.chainSystemsL = this.chainSystemsL.filter(x => x.SystemId != this.selectedChainRSide)
  }
  finishedLoading() {
    //this._loadingService.finishedLoading();
    this.isLoading = false;
  }

  customerChanged(event: any): void {
    this.selectedCustomer = event.value;
    if (!this.selectedCustomer) {
      return;
    }
    this._dropDownListsFiltered.jobSiteList = this._dropDownLists.jobSiteList.filter(
      m => m.CustomerId === this.selectedCustomer.Id
    );
    this.inventorySearchFilter.CustomerId = this.selectedCustomer.Id;
    this.inventorySearchFilter.JobsiteId = 0;
    this.selectedJobsite = null;


  }

  jobsiteChanged(event: any): void {
    this.selectedJobsite = event.value;
    if (!this.selectedJobsite) {
      return;
    }
    this.inventorySearchFilter.JobsiteId = this.selectedJobsite.Id;

  }

  makeChanged(event) {
    this.selectedMake = event.value;
    if (!this.selectedMake) {
      return;
    }
    this.inventorySearchFilter.MakeId = this.selectedMake.Id;

    // this._dropDownListsFiltered.modelList = this._dropDownLists.modelList.filter(
    //   m => m.MakeId === this.selectedMake.Id
    // );

    this._equipmentService.getModelList(this.selectedMake.Id).subscribe(res => {
      this.modelList = res;
      this.CopymodelList = res;
    });
    //  this.search();
  }


  // GetFrameList(){
  //   this.inventoryService.GetFrameForSelectedModel(this.selectedModel).subscribe(res=>{
  //     console.log("componentlist", res)
  //     this.componentList = res;
  //   })
  // }

  onNoClick() {
    this.dialogRef.close(true);
  }

  onClickStartInspection() {
    console.log("Inve", this.isInventory, this.isCreateNew)
    if (this.isInventory == false) {
      this.StartInspection_ChainSetup();
    } else {
      console.log("Start Inspection Chain")
      this.StartInspection_ChainInventory();
    }
  }

  StartInspection_ChainInventory() {
    if (this.isCreateNew == false) {
      if (this.selectedChainSide == 3)
        this.CreateInspection(0, this.selectedChainLSide, 0, this.selectedChainRSide);
      else if (this.selectedChainSide == 1)
        this.CreateInspection(0, this.selectedChainLSide, 0, 0);
      else if (this.selectedChainSide == 2)
        this.CreateInspection(0, 0, 0, this.selectedChainRSide);


    }
    else {
      console.log("Start Inspection Chain New")
      if (this.selectedChainSide == 3)
        this.CreateChainInspectionNew(0, this.selectedChainLSide, 0, this.selectedChainRSide);
      else if (this.selectedChainSide == 1)
        this.CreateChainInspectionNew(0, this.selectedChainLSide, 0, 0);
      else if (this.selectedChainSide == 2)
        this.CreateChainInspectionNew(0, 0, 0, this.selectedChainRSide);

    }

  }


  StartInspection_ChainSetup() {
    let arr_ = []
    let arr = [];
    //create Chain 
    let ob1 = new FrameVM()
    ob1.compartid = this.selectedChainLSide
    ob1.srialNo = this.selected_ChainNoLeft
    ob1.side = 1

    let ob2 = new FrameVM()
    ob2.compartid = this.selectedChainRSide
    ob2.srialNo = this.selected_ChainNoRight
    ob2.side = 2

    if (this.selectedChainSide == 3) {
      // arr.push(ob1,ob2)
      arr[0] = ob1
      arr[1] = ob2
    } else if (this.selectedChainSide == 1) {
      arr[0] = ob1
    } else if (this.selectedChainSide == 2) {
      arr[0] = ob2
    }
    console.log("arr[i].compartid", arr[0].compartid)
    console.log("arr[i].compartid", arr[0].srialNo)
    console.log("arr[i].compartid", arr[0].side)
    console.log("arr[i].compartid", arr[1].compartid)
    console.log("arr[i].compartid", arr[1].srialNo)
    console.log("arr[i].compartid", arr[1].side)
    for (let i = 0; i < arr.length; i++) {
      this.inventoryService.CeateFrameAndGEWForFrameWSRE(arr[i].compartid, this.selectedJobsite.Id, this.selectedMake.Id, this.selectedModel, arr[i].srialNo, arr[i].side).subscribe(result => {
        // console.log("data", result)
        arr_.push(result)
        console.log("arr_", arr_)

        this.leftSideChaininfo = arr_.filter(a => a.side == 1)
        this.rightSideChaininfo = arr_.filter(a => a.side == 2)
        console.log("this.leftSideChaininfo", this.leftSideChaininfo)
        console.log("this.rightSideChaininfo", this.rightSideChaininfo)

        if (this.leftSideChaininfo[0].EqunitId > 0 && this.leftSideChaininfo[0].EqunitId > 0 && this.rightSideChaininfo[0].SystemId > 0 && this.rightSideChaininfo[0].SystemId > 0) {
          console.log("obj____B", this.selectedChainSide)

          this.CreateInspection(this.leftSideChaininfo[0].EqunitId, this.leftSideChaininfo[0].SystemId, this.rightSideChaininfo[0].EqunitId, this.rightSideChaininfo[0].SystemId)
        }


      })
    }


  }

  CreateInspection(EqunitId: number, SysId: number, EqunitIdR: number, SysIdR: number) {
    let obj_ = new ModelCreateInspection()
    obj_["_date"] = this.selected_date
    obj_["_jobSiteId"] = this.selectedJobsite.Id
    obj_["_systemId"] = SysId
    obj_["_jobNumber"] = this.selected_jobNumber
    obj_["_customerRef"] = this.selected_customerRef
    obj_["_oldJobNo"] = this.selected_oldJobNo
    obj_["SystemTypeId"] = 1
    obj_["EqunitId"] = EqunitId
    obj_["_numberOfLinks"] = this.noofLinks;
    obj_["_systemId"] = this.selectedChainLSide;
    obj_["StringDate"] = this.datePipe.transform(this.selected_date, 'MM/dd/yyyy');;
    this.isLoading = true;
    this.inventoryService.WSRECreateNewInspection(obj_).subscribe(r => {
      if (r._status) {
        this.onNoClick()
        this.router.navigate(['/repair-estimate', r._inspectionID, 1]);
      } else {
      }
      this.isLoading = false;
    })
  }

  CreateChainInspectionNew(EqunitId: number, SysId: number, EqunitIdR: number, SysIdR: number) {
    let obj_ = new ModelCreateInspection()
    obj_["_date"] = this.selected_date
    obj_["_jobSiteId"] = this.jobsites
    obj_["_systemId"] = SysId
    obj_["_jobNumber"] = this.selected_jobNumber
    obj_["_customerRef"] = this.selected_customerRef
    obj_["_oldJobNo"] = this.selected_oldJobNo
    obj_["SystemTypeId"] = 2
    obj_["EqunitId"] = EqunitId
    obj_["TrackChain_Right_SystemId"] = SysIdR
    obj_["TrackChain_Customer_L_Serial"] = this.selected_customerChainLeft
    obj_["TrackChain_Customer_R_Serial"] = this.selected_customerChainRight
    obj_["ChainSerial_Left"] = this.selected_Chain_L
    obj_["ChainSerial_Right"] = this.selected_Chain_R

    obj_["ChainInspectedSide"] = this.selectedChainSide
    obj_["StringDate"] = this.datePipe.transform(this.selected_date, 'MM/dd/yyyy');

    this.isLoading = true;
    this.inventoryService.POSTCreateWSREInspectionFrame(obj_).subscribe(r => {
      console.log("r", r)

      if (r._status) {
        this.onNoClick()
        this.router.navigate(['/repair-estimate-Frame', r._inspectionID, 1])
          .then(() => {
            window.location.reload();
          });
      } else {
      }
      this.finishedLoading();
    })



  }
  changeModelAutoComplete(event) {
    const filterValue = event.target.value.toLowerCase();

    this.modelList = this.CopymodelList.filter(option => option.Name.toLowerCase().includes(filterValue));
  }

  modelTitle: String;
  model_auto_: number;

  modelselect(modelid) {
    console.log("this.modelTitle", modelid, this.modelList)

    this.model_auto_ = this.modelList.find(f => f.Name == modelid).Id;
    this.selectedModel = this.modelList.find(f => f.Name == modelid).Id;

    console.log("model_auto_", this.model_auto_, this.selectedModel)
    this.inventorySearchFilter.ModelId = this.selectedModel;
    this.inventoryService.GetFrameForSelectedModelLeft(this.selectedModel).subscribe(res => {

      this.componentList = res;

      if (this.componentList.length == 1) {
        this.selectedChainLSide = this.componentList[0].CompartId;
      }
      // this.componentListLEFT=  this.componentList.filter
    })

    this.inventoryService.GetFrameForSelectedModelRight(this.selectedModel).subscribe(res => {

      this.componentList_ = res;
      if (this.componentList_.length == 1) {
        this.selectedChainRSide = this.componentList_[0].CompartId;
      }
      // this.componentListLEFT=  this.componentList.filter
    })

  }

  checkSerialNoLeft(event) {
    this.selected_ChainNoLeft = event.target.value
    if (this.selected_ChainNoLeft != "") {

      this.inventoryService.VerifyserilaNo(event.target.value).subscribe(res => {

        if (res == false) {
          this._notify.error('Operation failed!', 'That system serial number already exists! Please enter a valid serial number');
        }
        else {
          this._notify.success('Serial number validated');
        }

      })
    }
  }

  checkSerialNoRight(event) {
    this.selected_ChainNoRight = event.target.value
    if (this.selected_ChainNoRight != "") {
      if (this.selected_ChainNoLeft == this.selected_ChainNoRight) {
        this._notify.error('Operation failed!', 'That system serial numbers cannot be same! Please enter a valid serial number');
      }
      else {
        this.inventoryService.VerifyserilaNo(event.target.value).subscribe(res => {

          if (res == false) {
            this._notify.error('Operation failed!', 'That system serial number already exists! Please enter a valid serial number');
          }
          else {
            this._notify.success('Serial number validated');
          }

        })

      }
    }

  }

  getCustomerChainNoLeft(event) {
    this.selected_customerChainLeft = event.target.value
  }
  getCustomerChainNoRight(event) {
    this.selected_customerChainRight = event.target.value
  }
  getDate(event) {
    this.selected_date = event.target.value
    console.log(this.selected_date, "selected date")
    this.stringDate = this.datePipe.transform(this.selected_date, 'MM/dd/yyyy');
    console.log(this.stringDate, "selected date")
  }
  getCustomerReference(event) {
    this.selected_customerRef = event.target.value
  }

  getJobNumber(event) {
    this.selected_jobNumber = event.target.value
  }

  getOldJobNumber(event) {
    this.selected_oldJobNo = event.target.value
  }
  getNoonLinks(event) {
    this.noofLinks = event.target.value
  }
  showSelectedSide(id: number) {
    if (id == 3) {
      this.inventorySearchFilter.ShowBoth = true;
    } else {
      this.inventorySearchFilter.ShowBoth = false;

    }
    console.log("selectedChainSide", this.selectedChainSide)
  }
}
